"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SERVICE_FIELD_META = void 0;
var SERVICE_FIELD_META = [
    { key: "name", label: "Service Name", group: "Basic" },
    { key: "serviceType", label: "Service Type", group: "Basic" },
    { key: "serviceCategory", label: "Service Category", group: "Basic" },
    { key: "level", label: "Service Level", group: "Basic" },
    { key: "supplier", label: "Supplier", group: "Basic" },
    { key: "isActive", label: "Active", group: "Basic" },
    { key: "buildingName", label: "Building", group: "Linkage" },
    { key: "startDate", label: "Start Date", group: "Dates" },
    { key: "endDate", label: "End Date", group: "Dates" },
    { key: "chartOfAccountCode", label: "Chart of Account Code", group: "Billing" },
    { key: "chargeRateId", label: "Charge Rate", group: "Billing" },
    { key: "sourceType", label: "Source Type", group: "Source" },
    { key: "supplySource", label: "Supply Source", group: "Source" },
    { key: "municipalityName", label: "Municipality", group: "Source" },
    { key: "resourceOptions", label: "Resource Type", group: "Source" },
    { key: "supplierDetails", label: "Supplier Details", group: "Source" },
    { key: "buildingServiceMeter", label: "Building Service Meter", group: "Source" },
    { key: "isBilledDirectlyByEskom", label: "Billed Directly by Eskom", group: "Power" },
    { key: "locality", label: "Locality", group: "Power" },
    { key: "transmissionZone", label: "Transmission Zone", group: "Power" },
    { key: "voltageLevel", label: "Voltage Level", group: "Power" },
    { key: "hasGridTiedGeneration", label: "Grid-Tied Generation", group: "Power" },
    { key: "nmdKva", label: "NMD (kVA)", group: "Power" },
    { key: "isPrepaid", label: "Prepaid", group: "Power" },
    { key: "phases", label: "Phases", group: "Power" },
    { key: "mainBreakerAPerPhase", label: "Main Breaker (A / phase)", group: "Power" },
    { key: "meterType", label: "Meter Type", group: "Power" },
    { key: "waterMeterTypes", label: "Water Meter Type", group: "Water" },
    { key: "solar", label: "Solar", group: "Resource" },
    { key: "gas", label: "Gas", group: "Resource" },
    { key: "bess", label: "BESS", group: "Resource" },
    { key: "generator", label: "Generator", group: "Resource" },
    { key: "boreHole", label: "Borehole", group: "Resource" },
    { key: "notes", label: "Notes", group: "Other" },
];
exports.SERVICE_FIELD_META = SERVICE_FIELD_META;
